var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.templateRadio = '';
        _this.dataList = [];
        _this.formData = {};
        _this.form = {};
        return _this;
    }
    AddGoods.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = 'id'; }
        if (name === void 0) { name = 'name'; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        this.gitRightList();
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.templateRadio = '';
        this.url(Object.assign({}, this.searchData, pager)).then(function (res) {
            console.log(44555, res.data);
            if (res.data.success) {
                _this.dataList = Array.isArray(res.data.data) ? res.data.data : [];
                _this.total = res.data.count || res.data.total;
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.changeSelection = function (index, row) {
        console.log(index, row);
        this.selectRows = row;
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        this.$emit('saveGoodOrActivity', this.selectRows);
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], AddGoods.prototype, "showDialog", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], AddGoods.prototype, "title", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "categoryList", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "tableColumnList", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "FormModel", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "searchData", void 0);
    __decorate([
        Prop({
            type: Function
        })
    ], AddGoods.prototype, "url", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "param", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "selectedNote", void 0);
    AddGoods = __decorate([
        Component({
            components: {}
        })
    ], AddGoods);
    return AddGoods;
}(Vue));
export default AddGoods;
